// extracted by mini-css-extract-plugin
module.exports = {"cover":"podcast-cover-image-module--cover--3pYN7"};